import axios from "axios";
import { saveAs } from "file-saver";

export function exportGroupVisits(groupId, startDate, endDate) {
    return axios.request({
        url: `/api/session-count/${groupId}/export`,
        params: {
            startDate,
            endDate
        },
        method: "GET",
        responseType: 'blob'
    }).then(({data}) => {
        const blob = new Blob([data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        saveAs(blob, 'export.xlsx')
    });
}
